import { render, staticRenderFns } from "./UploadedDataView.vue?vue&type=template&id=d1c1aec8"
import script from "./UploadedDataView.vue?vue&type=script&lang=js"
export * from "./UploadedDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports